export const UPLOADING = 1
export const SUCCESS = 2
export const ERROR = 3



// WEBPACK FOOTER //
// ./~/rctui/Upload/status.js